import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1d46fb7f&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d46fb7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d46fb7f')) {
      api.createRecord('1d46fb7f', component.options)
    } else {
      api.reload('1d46fb7f', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1d46fb7f&scoped=true&", function () {
      api.rerender('1d46fb7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FiNDHS0Pcbep/JS/comp/SearchFilterTokens.vue"
export default component.exports